export default {
  translation: {
    common: {
      emailOrUsername: 'E-mail vagy felhasználó',
      invalidEmailOrUsername: 'Érvénytelen e-mail vagy felhasználó',
      invalidPassword: 'Érvénytelen jelszó',
      logInToPlanka: 'Plankába belépés',
      noInternetConnection: 'Nincs internet kapcsolat',
      pageNotFound_title: 'Az oldal nem található',
      password: 'Jelszó',
      projectManagement: 'Projektmenedzsment',
      serverConnectionFailed: 'A szerverkapcsolat sikertelen',
      unknownError: 'Ismeretlen hiba, próbáld meg később újra',
      useSingleSignOn: 'Egyszeri bejelentkezés használata',
    },

    action: {
      logIn: 'Belépés',
      logInWithSSO: 'Belépés SSO-val',
    },
  },
};
